const IndicativeSellingPriceValidator = {
  validate(indicativeSellingPrice) {
    let errors = {};
    const {
      singlePrice,
      sellingPriceType,
      priceRange: {min, max},
    } = indicativeSellingPrice;
    if (sellingPriceType === 'single-price') {
      if (!singlePrice) {
        errors.singlePrice = 'Please enter an amount';
      }
    }
    if (sellingPriceType === 'price-range') {
      if (!min || !max) {
        if (!min) {
          errors.min = 'Please enter an amount';
        }
        if (!max) {
          errors.max = 'Please enter an amount';
        }
      } else {
        if (min >= max) {
          errors.min = 'min price must be lower than max price';
        }
      }
    }
    return errors;
  }
};

export default IndicativeSellingPriceValidator;